import { FunctionComponent } from "react";

import {
  ComponentDefinitionSelect,
  ComponentDefinitionSelectProps
} from "../../pickers/ComponentDefinitionSelect";
import { useFieldContext, useFieldRegister } from "@bps/fluent-ui";

type FormComponentDefinitionSelectProps = Omit<
  ComponentDefinitionSelectProps,
  "selectedKeys" | "onChangeSelectedKeys"
> & { name: string };

export const FormComponentDefinitionSelect: FunctionComponent<FormComponentDefinitionSelectProps> = ({
  name,
  ...rest
}) => {
  useFieldRegister(name);
  const { value, setFieldValue } = useFieldContext<
    string | string[] | undefined
  >(name);

  return (
    <ComponentDefinitionSelect
      selectedKeys={value}
      onChangeSelectedKeys={setFieldValue}
      {...rest}
    />
  );
};
